import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ParamTable from '../ParamTable';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const Diets = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          {/*
                       <Grid item xs={2}><h3>Example Request</h3></Grid>
                      <Grid item xs={10}>
                      <pre className={classes.pre}>
                      <code>
                    </code>
                      </pre>
                      </Grid>
                      */}
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "data": [
        "PAL",
        "KET",
        "LOC",
        "SOU",
        "AME",
        "LOF",
        "TLC",
        "AHA",
        "DSH",
        "MND",
        "MED",
        "NRM",
        "FLX",
        "PES",
        "VET",
        "VEG",
        "WFP",
        "WFR",
        "MEX",
        "SA",
        "SA_V"
    ]
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <Diets />
    </React.Suspense>
  );
};
export default Wrapper;
